<template>
<div v-show="show">
    <div class="model">
        <div class="box">
            <van-datetime-picker v-model="currentDate" type="datetime" title="选择时间" @confirm="confirm" @cancel="cancel" />
        </div>
        <div class="mark"></div>
    </div>
</div>
</template>

<script>
export default {
    name: "date-time",
    data() {
        return {
            show: false,
            currentDate: "",
        };
    },
    methods: {
        open() {
            this.currentDate = new Date();
            this.show = true;
        },
        confirm(e) {
            let res = this.formatDate(e)
            this.$emit("confirm", res);
            this.show = false;
        },
        cancel() {
            this.show = false;
        },
        formatDate(date) {
            date = new Date(date);
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var day = date.getDate();
            var hour = date.getHours();
            var minute = date.getMinutes();
            var second = date.getSeconds();
            return (
                year +
                "-" +
                this.formatTen(month) +
                "-" +
                this.formatTen(day) +
                " " +
                this.formatTen(hour) +
                ":" +
                this.formatTen(minute)
            );
        },
        formatTen(num) {
            return num > 9 ? num + "" : "0" + num;
        },
    },
    created() {
        // 实例创建完成
    },
};
</script>

<style lang="less" scoped>
.box {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
}

.mark {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    z-index: 99;
    background-color: rgba(0, 0, 0, 0.4);
}
</style>
